export default "__VITE_ASSET__8070c560__"